const gardenCategories = [
    {
        title: {
            de: "Weidezäune",
            nl: "Weideafrastering"
        },
        description: {
            de: "Zuverlässige Weidezäune für sichere Einzäunung von Pferden und Weideflächen – langlebig, stabil und einfach zu montieren.",
            nl: "Betrouwbare afrasteringen voor veilige omheining van paarden en weides – duurzaam, stabiel en eenvoudig te installeren."
        },
        brands: "Lerns wegen",
        image: "images_general/zaun.jpg"
    },
    {
        title: {
            de: "Mistgabeln und Stallwerkzeug",
            nl: "Mestvorken en stalgereedschap"
        },
        description: {
            de: "Robuste Mistgabeln und praktisches Stallwerkzeug für die tägliche Arbeit – effizient und ergonomisch.",
            nl: "Stevige mestvorken en praktisch stalgereedschap voor dagelijks gebruik – efficiënt en ergonomisch."
        },
        brands: "Lerns wegen",
        image: "images_general/img.png"
    },
    {
        title: {
            de: "Schaufeln und Werkzeug",
            nl: "Schoppen en gereedschap"
        },
        description: {
            de: "Hochwertige Schaufeln und vielseitige Werkzeuge für Stall, Garten und Hof – ideal für jede Aufgabe.",
            nl: "Hoogwaardige schoppen en veelzijdig gereedschap voor stal, tuin en erf – geschikt voor elke klus."
        },
        brands: "Lerns wegen",
        image: "images_general/besen.webp"
    },
    {
        title: {
            de: "Parasitenbekämpfung (natürlich)",
            nl: "Parasietenbestrijding (natuurlijk)"
        },
        description: {
            de: "Umweltfreundliche Lösungen zur Bekämpfung von Parasiten – schonend für Tier und Natur.",
            nl: "Milieuvriendelijke oplossingen voor het bestrijden van parasieten – veilig voor dier en natuur."
        },
        brands: "Lerns wegen",
        image: "images_general/img.png"
    },
    {
        title: {
            de: "Weidepflege",
            nl: "Weideonderhoud"
        },
        description: {
            de: "Alles für die Pflege deiner Weide – für gesunde Böden und optimale Bedingungen für deine Tiere.",
            nl: "Alles voor het onderhoud van je weide – voor gezonde bodems en optimale omstandigheden voor je dieren."
        },
        brands: "Lerns wegen",
        image: "images_general/img.png"
    },
    {
        title: {
            de: "Garten- und Hofbedarf",
            nl: "Tuin- en erfbenodigdheden"
        },
        description: {
            de: "Praktische Helfer für Garten und Hof – von Transport bis Pflege alles aus einer Hand.",
            nl: "Praktische hulpmiddelen voor tuin en erf – van transport tot onderhoud alles in één."
        },
        brands: "Lerns wegen",
        image: "images_general/img.png"
    }
];

export default gardenCategories;
